<template>
	<div class="case-status-box card">
		<div class="status-title">
			<div class="header4">Status:&nbsp;{{ statusText }}</div>
			<div class="icon-sec">
				<i class="material-icons">done</i>
			</div>
		</div>
		<div class="summary-sec">
			<div class="paragraph">
				Congratulations, for more details on your case view the results letter, make sure to keep a copy of the file with you on your computer
			</div>
		</div>
	</div>
</template>

<script>
import Button from "@/components/ui/Button.vue";

export default {
	name: "casestatusbox",
	components: {
		Button,
	},
	computed: {
		statusText() {
			return this.$store.getters.getCaseData.statusText;
		},
		// caseNumber() {
		// 	return this.$store.state.account.caseNumber;
		// },
		// caseAmount() {
		// 	return 200;
		// },
		// caseMaxPayDate() {
		// 	return "12/20/2020";
		// },
	},
	methods: {
		// method parts
		// isCaseSuccessfull() {
		// 	if (this.caseStatus == "50") {
		// 		return true;
		// 	} else {
		// 		return false;
		// 	}
		// },
		// goToPayment() {
		// 	this.$router.push({ name: "Payment" });
		// },
	},
};
</script>

<style scoped lang="scss">
.case-status-box {
	padding: 30px;
	text-align: left;
	.header4 {
		color: var(--dark-gray);
	}
	.status-title {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 15px;
	}
	.icon-sec {
		background: var(--accent);
		border-radius: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-decoration: none;
		list-style: none;
		width: 48px;
		height: 48px;
		color: white;
	}
	.paragraph {
		color: var(--black);
		opacity: 0.5;
	}
	.summary-sec .button {
		margin: 15px 0;
		width: 100%;
	}
}
</style>
